<div class="section-header">
    <div class="title">
        Hardware
    </div>
    <!--    &lt;!&ndash;    this input makes form invalid if  devices accessories and supplies tabs are empty &ndash;&gt;-->
    <!--    <app-amount-input [ngModel]="model.someItemContainerIsActive" [showIcon]="false"-->
    <!--        [name]="'someItemContainerIsActive'" [bdMinNumber]="1" class="validator-helper"-->
    <!--        [forceFormValidationVisibility]="forceFormValidationVisibility" #validationHelperNgModel="ngModel">-->
    <!--    </app-amount-input>-->
    <!--    -->
    <!--    <bd-input-error-viewer [ngModelRef]="validationHelperNgModel"-->
    <!--                           [customErrorsMsg]="{'isBdMinNumber': 'Bitte wählen Sie mindestens ein Gerät oder Verbrauchsmaterial aus.'}"-->
    <!--                           class="error-viewer">-->
    <!--    </bd-input-error-viewer>-->

    <div class="button-container">


        <app-amount-input [ngModel]="model.someDeviceTableContainerIsActive"
                          [showIcon]="false"
                          [name]="'someDeviceTableContainerIsActive'"
                          [bdMinNumber]="1"
                          class="validator-helper">
        </app-amount-input>


        <div class="no-hardware-btn" (click)="onRemoveHardwareFromOrderBtnLicked()"
             [ngClass]="{'invalid':(forceFormValidationVisibility || model.isStep3ButtonsValidationVisibilityForced) && model.someDeviceTableContainerIsActive === 0} ">
            Nichts hinzufügen
        </div>

        <button (click)="onAddDeviceBtnClicked()" class="btn-add-device" type="button"
                [ngClass]="{'invalid' : (forceFormValidationVisibility || model.isStep3ButtonsValidationVisibilityForced) && !projectRowItemsAmountComplyRules()}">
            <bd-fa-button [name]="activeSpinnerId === addArticleNumberSpinnerID ? 'refresh fa-spin' : 'plus'">
            </bd-fa-button>
            <span>Artikel hinzufügen</span>
        </button>

        <!--        <button (click)="onAddDeviceBtnClickedOld()" type="button"-->
        <!--                [ngClass]="{'invalid' : forceFormValidationVisibility && !projectRowItemsAmountComplyRules()}">-->
        <!--            <bd-fa-button [name]="activeSpinnerId === addArticleNumberSpinnerID ? 'refresh fa-spin' : 'plus'">-->
        <!--            </bd-fa-button>-->
        <!--        </button>-->
    </div>


</div>


<ng-container *ngIf="projectHasRequestedProducts()">


    <div class="table">
        <div class="table-header" [ngClass]="{'notify-change' : notifyChange( pUNFEnum.PRODUCTS)}">
            <div class="table-header-column">Anzahl</div>
            <div class="table-header-column">Artikel</div>
            <div class="table-header-column amounts">Mtl. Druckvolumen pro Gerät</div>
        </div>

        <div class="table-body">

            <ng-container *ngIf="model.requestedDevicesContainers.length">
                <div class="table-row category-row">
                    <div class="category-column-cell">
                        Geräte
                    </div>
                </div>
                <ng-container *ngFor="let deviceContainer of model.requestedDevicesContainers">
                    <div class="table-row device"
                         [ngClass]="{ 'print-smart': isSmartPrint(deviceContainer.itemToOrder)}">
                        <div class="amount-column-cell">
                            <app-amount-input [(ngModel)]="deviceContainer.deviceAmount.amount" [showIcon]="false"
                                              [minNumber]="0" [incrementViaMouseWheel]="false" [bdMinNumber]="1"
                                              [forceFormValidationVisibility]="forceFormValidationVisibility" required
                                              [name]="deviceContainer.id +'-amount-input_datc'"
                                              #dynamicInput="ngModel">
                            </app-amount-input>


                        </div>


                        <div class="article-column-cell">

                            <div class="product-label-container">
                                <app-product-label [orderItemContainer]="deviceContainer"></app-product-label>
                            </div>


                            <div class="icon-container">
                                <div class="print-smart-icon" *ngIf="isSmartPrint(deviceContainer.itemToOrder)">
                                    <img [res-src]="'./assets/img/logo-print-smart/icon_mps.png'"
                                         [res-sizes]="['2x', '3x']"/>
                                </div>
                            </div>

                        </div>


                        <div class="page-amounts-column-cell">
                            <ng-container *ngIf="isSmartPrint( deviceContainer.itemToOrder )">
                                <app-amount-input
                                    [(ngModel)]="deviceContainer.deviceRequest.metaData.monoPageCountPerMonth"
                                    [name]="deviceContainer.id + 'monoPageCountPerMonthTest_datc'"
                                    [forceFormValidationVisibility]="forceFormValidationVisibility"
                                    required
                                    [minNumber]="0"
                                    [bdMinNumber]="1"
                                    #dynamicInput="ngModel">

                                    <img src="./assets/img/icon_printvolume_monochrome.svg"
                                         alt="icon printvolume monochrome">
                                </app-amount-input>
                                <app-amount-input *ngIf="isColorPrinter( deviceContainer.itemToOrder )"
                                                  [(ngModel)]="deviceContainer.deviceRequest.metaData.colorPageCountPerMonth"
                                                  [name]="deviceContainer.id + 'colorPageCountPerMonth_datc'"
                                                  [forceFormValidationVisibility]="forceFormValidationVisibility"
                                                  required
                                                  [minNumber]="0"
                                                  [bdMinNumber]="1"
                                                  #dynamicInput="ngModel">
                                    <img src="./assets/img/icon_printvolume_cmyk.svg" alt="icon printvolume cmyk">
                                </app-amount-input>
                            </ng-container>

                        </div>

                        <div class="button-cell">
                            <button (click)="onRemoveItemBtnClicked( deviceContainer )" type="button">
                                <bd-fa-button [name]="'times'"></bd-fa-button>
                            </button>
                        </div>

                    </div>

                </ng-container>
            </ng-container>

        </div>

    </div>
</ng-container>



